import ImageWrapper from "@/components/ImageComponent/ImageWrapper";
import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Link from "next/link";
import InputTextComponent from "@/components/InputComponent/InputTextComponent";
import MultiSelectFieldset from "@/components/InputComponent/MultiSelectComponent";
import InputNumberComponent from "@/components/InputComponent/InputNumberComponent";
import InputDateComponent from "@/components/InputComponent/InputDateComponent";
import InputFileComponent from "@/components/InputComponent/InputFileComponent";
import SelectFieldset from "@/components/InputComponent/SelectComponent";
import { addPandit } from "../api";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import SuccessModal from "@/components/modalcomponent/SuccessModal";
const data = {
  firstName: {
    type: "text",
    placeholder: "Enter First Name",
    defaultValue: "Enter First Name",
    required: true,
    label: "First Name",
    isOTPRequired: false,
    priority: 1,
    value: "",
    inputKey: "firstName",
  },
  lastName: {
    type: "text",
    placeholder: "Enter Last Name",
    defaultValue: "",
    required: true,
    label: "Last Name",
    isOTPRequired: false,
    priority: 2,
    error: null,
    value: "",
    inputKey: "lastName",
  },
  phone: {
    type: "number",
    placeholder: "Enter Phone Number",
    defaultValue: "",
    required: true,
    label: "Phone",
    isOTPRequired: true,
    priority: 3,
    error: null,
    value: "",
    inputKey: "phone",
  },
  email: {
    type: "text",
    placeholder: "Enter Email",
    defaultValue: "",
    required: false,
    label: "Email",
    isOTPRequired: true,
    priority: 4,
    error: null,
    value: "",
    inputKey: "email",
  },
  education: {
    type: "select",
    options: [
      { value: "1", label: "Select Education" },
      { value: "2", label: "Graduate" },
      { value: "3", label: "Post Graduate" },
      { value: "4", label: "Doctorate" },
    ],
    placeholder: "",
    defaultValue: "",
    required: false,
    label: "Education",
    isOTPRequired: false,
    priority: 6,
    error: null,
    value: "",
    inputKey: "education",
  },
  experience: {
    type: "number",
    placeholder: "Experience",
    defaultValue: "",
    required: true,
    label: "Experience",
    isOTPRequired: false,
    priority: 7,
    error: null,
    value: "",
    inputKey: "experience",
  },
  areaOrLocality :{
    type:"text",
    placeholder: "Enter Area or locality",
    defaultValue:"",
    required: false,
    label:"Area Or Locality",
    isOTPRequired: false,
    priority: 8,
    error: null,
    value: "",
    inputKey: "areaOrLocality",
  },
  city: {
    type: "text",
    placeholder: "Enter City",
    defaultValue: "",
    required: true,
    label: "City",
    isOTPRequired: false,
    priority: 9,
    error: null,
    value: "",
    inputKey: "city",
  },
  state: {
    type: "text",
    placeholder: "Enter State",
    defaultValue: "",
    required: true,
    label: "State",
    isOTPRequired: false,
    priority: 10,
    error: null,
    value: "",
    inputKey: "state",
  },
  languages: {
    type: "multi-select",
    placeholder: "Enter languages",
    options: [],
    defaultValue: "",
    required: true,
    label: "languages",
    isOTPRequired: false,
    priority: 11,
    error: null,
    value: "",
    inputKey: "languages",
  },
  poojasPerformed: {
    type: "multi-select",
    placeholder: "Enter Pooja Performed",
    options: [
      { value: "Birthday Pooja", label: "Birthday Pooja" },
      { value: "Upanayan", label: "Upanayan" },
      { value: "Garbhadhan", label: "Garbhadhan" },
      { value: "God Bharai", label: "God Bharai" },
      {
        value: "Griha Pravesh / House Warming",
        label: "Griha Pravesh / House Warming",
      },
      { value: "New Vehicle", label: "New Vehicle" },
      { value: "SatyaNarayan", label: "SatyaNarayan" },
      { value: "Wedding", label: "Wedding" },
      { value: "Last Rites", label: "Last Rites" },
      { value: "Annaprashan", label: "Annaprashan" },
      { value: "Kalsarp Shanti", label: "Kalsarp Shanti" },
      { value: "Astrology Consultation", label: "Astrology Consultation" },
    ],
    defaultValue: "",
    required: true,
    label: "Pooja Performed",
    isOTPRequired: false,
    priority: 12,
    error: null,
    value: "",
    inputKey: "poojasPerformed",
  },
  dateOfBirth: {
    type: "date",
    placeholder: "Select Date Of Birth",
    defaultValue: "",
    required: false,
    label: "Date Of Birth",
    isOTPRequired: false,
    priority: 5,
    error: null,
    value: "",
    inputKey: "dateOfBirth",
  },
  identityProof: {
    type: "select",
    placeholder: "Select Identity Proof",
    options: [
      { value: "Aadhar Card", label: "Aadhar Card" },
      { value: "Voter Card", label: "Voter Card" },
      { value: "Passport", label: "Passport" },
      { value: "Others", label: "Others" },
    ],
    error: null,
    defaultValue: "",
    required: false,
    label: "Identity Proof",
    isOTPRequired: false,
    priority: 13,
    value: "",
    inputKey: "identityProof",
  },
  identityProofAttachment: {
    type: "file",
    placeholder: "Select File Input",
    defaultValue: "",
    required: false,
    label: "Select Identity Proof Attachment",
    isOTPRequired: false,
    priority: 14,
    error: null,
    value: "",
    inputKey: "identityProofAttachment",
  },
  upiId: {
    type: "text",
    placeholder: "Select UPI ID",
    defaultValue: "",
    required: false,
    label: "Select UPI ID",
    isOTPRequired: false,
    priority: 15,
    error: null,
    value: "",
    inputKey: "upiId",
  },
  
};

const initialFormData = {
  firstName: "",
  lastName: "",
  phone: "",
  email: "",
  education: "",
  experience: "",
  city: "",
  state: "",
  languages: [],
  poojasPerformed: [],
  dateOfBirth: "",
  identityProof: "",
  identityProofAttachment: "",
  upiId: "",
  areaOrLocality: ""
};
const PanditRegistration = () => {
  const [validForm, setValidForm] = useState(false);
  const [formData, setFormData] = useState(initialFormData);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const { languages: reduxLanguages, locations: reduxLocations } = useSelector(
    (state) => state.locationandlanguages
  );

  const formattedLanguages = reduxLanguages?.body?.map((i) => {
    return {
      value: i._id,
      label: i.languageName,
    };
  });
  if (formattedLanguages) {
    data.languages.options = formattedLanguages;
  }

  const router = useRouter();
  const onInputChange = (e) => {
    const { name, value } = e.target;
    if (!Object.keys(formData).includes(name)) {
      return;
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const checkIfFormIsValid = () => {
    for (let key in data) {
      if (data[key].required) {
        if (
          formData[key] === "" || // Empty string check
          (Array.isArray(formData[key]) && formData[key].length === 0) // Empty array check
        ) {
          setValidForm(false);
          return;
        }
      }
    }
    setValidForm(true);
  };

  const onPanditSubmit = async () => {
    try {
      const res = await addPandit(formData);

      if (res.status === 201 && res.data.statusCode === 200) {
        setShowSuccessModal(true);
      } else {
        toast.error("Failed to add pandit");
      }
    } catch (e) {
      toast.error("Failed to add pandit");
    }
  };

  useEffect(() => {
    checkIfFormIsValid();
  }, [formData]);

  return (
    <div className="relative flex flex-col md:top-0 left-0 xs:pb-10 w-full h-full items-center justify-center bg-white min-h-screen">
      <div className="flex w-full justify-center">
        <div className="w-48 h-24" onClick={() => router.push("/")}>
          <ImageWrapper src="/icons/book-my-pooja.svg" className="object-fit" />
        </div>
      </div>
      <div className=" flex flex-col w-full md:pt-0 md:-mt-8 p-0 md:w-2/3 lg:w-1/2 xl:w-1/3 justify-between bg-no-repeat bg-cover">
        <main className="h-full flex flex-col justify-start">
          <header className="flex justify-between items-center border-b p-4">
            <div className="flex items-center gap-2">
              <h3 className="font-semibold">Pandit Registration Form</h3>
            </div>
          </header>
          <div className="overflow-y-scroll md:max-h-[60vh] lg:max-h-[70vh] xl:max-h[100vh] max-h-[50vh] scrollbar border-b">
            <section className="flex flex-col gap-3 p-4 mb-10">
              {Object.keys(data).map((key) => {
                const componentProps = {
                  data: data[key],
                  value: formData[key],
                  onInputChange: onInputChange,
                };
                switch (data[key].type) {
                  case "select":
                    return <SelectFieldset {...componentProps} />;
                  case "multi-select":
                    return <MultiSelectFieldset {...componentProps} />;
                  case "text":
                    return <InputTextComponent {...componentProps} />;
                  case "number":
                    return <InputNumberComponent {...componentProps} />;
                  case "date":
                    return <InputDateComponent {...componentProps} />;
                  case "file":
                    return <InputFileComponent {...componentProps} />;
                  default:
                    return null;
                }
              })}
            </section>
          </div>
        </main>
      </div>
      <div className="mx-auto text-center text-[10px] py-7 text-Default md:w-2/3 lg:w-1/2 xl:w-1/3">
        <p>
          <Link href="/terms-and-conditions" className="text-BluntRed">
            Terms and Conditions
          </Link>{" "}
          and{" "}
          <Link href="/privacy-policy" className="text-BluntRed">
            Privacy Statement
          </Link>{" "}
          of Bookmypooja
        </p>

        <button
          disabled={validForm ? false : true}
          type="submit"
          className={`flex items-center justify-center w-full p-4 rounded-lg text-sm tracking-wider leading-5 ${
            !validForm
              ? "bg-opacity-60 text-Default bg-gray-300 border border-HeaderQuote"
              : "bg-opacity-100 bg-BluntRed  hover:bg-HoverModalButtonColor text-white"
          }`}
          onClick={onPanditSubmit}
        >
          Register
        </button>
      </div>
      
      <SuccessModal
        isOpen={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        title="Registration Successful!"
        message="Thank you for joining BookMyPooja. Your pandit account has been created successfully. Our team will review your profile and get in touch with you shortly."
        buttonText="Back to Home"
        onButtonClick={() => router.push("/")}
      />
    </div>
  );
};

export default PanditRegistration;
